module.exports = __webpack_public_path__ + "entry-150bfe9b/stefanie-klock.256x256-5fd645e2309c8eaa2eb4628599b05d8d.webp";